var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showGrid,
          expression: "showGrid",
        },
      ],
      class: [
        "grid-container",
        { "is-portal": _vm.isPortalUser, "is-in-tab": _vm.isInTab },
      ],
    },
    [
      _vm.showHeader
        ? _c(
            "header",
            [
              _c("AlertComponent", {
                attrs: {
                  whereIsRendered: _vm.componentWhereIsRenderedAlertComponent,
                },
              }),
              _vm.title
                ? _c("LfHeaderTitleComponent", {
                    staticClass: "header-title",
                    attrs: { title: _vm.title },
                  })
                : _vm._e(),
              _vm.totals && _vm.totals.length
                ? [
                    _c("v-spacer"),
                    _c("ShowOrHideTotalsButtonComponent", {
                      attrs: { showTotals: _vm.showTotals },
                      on: { "toggle-totals": _vm.toggleTotals },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "top-slot" },
        [
          _vm._t("top", function () {
            return [
              _vm.totals && _vm.totals.length && _vm.showTotals
                ? _c("TotalsContainerComponent", {
                    attrs: { items: _vm.totals },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _c(
        "ejs-grid",
        _vm._b(
          {
            ref: "grid",
            class: [
              "grid-table",
              _vm.checkIfToolbarIsHidden,
              _vm.checkIfClickCellDisabled,
            ],
          },
          "ejs-grid",
          _vm.gridProps,
          false
        ),
        [
          _c(
            "e-columns",
            _vm._l(_vm.parsedColumns, function (column, index) {
              return _c("e-column", {
                key: `column-${index}`,
                attrs: {
                  clipMode: _vm.getClipMode(column),
                  allowFiltering: column.allowFiltering,
                  allowReordering: column.allowReordering,
                  allowResizing: column.allowResizing,
                  allowSorting: column.allowSorting,
                  field: column.field,
                  isPrimaryKey: column.isPrimaryKey ? true : false,
                  filter: _vm.parsedFilter(column),
                  filterModule: column.filterModule,
                  foreignKeyField: column.foreignKeyField,
                  format: column.format,
                  headerTextAlign: column.headerTextAlign,
                  headerText: column.headerText,
                  minWidth: column.minWidth,
                  showInColumnChooser: column.showInColumnChooser,
                  template: _vm.getTemplate(column),
                  customAttributes: _vm.getCustomAttributes(
                    column.customAttributes
                  ),
                  type: column.type,
                  visible: column.visible,
                  width: column.width,
                  textAlign: column.textAlign,
                  maxWidth: column.maxWidth,
                  freeze: column.freeze ? column.freeze : null,
                  commands: column.commands,
                  tags: column.tags,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("ejs-contextmenu", {
        ref: "contextMenuComponent",
        staticClass: "context-menu-component",
        attrs: {
          id: "contextMenuComponent",
          items: _vm.renderedContextMenuItems,
          select: _vm.contextMenuClickedItem,
          beforeOpen: _vm.onContextMenuBeforeOpen,
        },
      }),
      _c("ejs-contextmenu", {
        ref: "customToolbarContextMenuComponent",
        staticClass: "custom-toolbar-context-menu-component",
        attrs: {
          id: "customToolbarContextMenuComponent",
          items: _vm.customToolbarContextMenuItemsParsed,
          select: _vm.customToolbarContextMenuClickedItem,
          beforeOpen: _vm.onCustomToolbarContextMenuBeforeOpen,
        },
      }),
      _c("OpenFileComponent", { ref: "openFileComponent" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }